import { ComponentSingleStyleConfig } from '@chakra-ui/react';

const Checkbox: ComponentSingleStyleConfig = {
  baseStyle: {
    control: {
      border: '2px solid',
      borderColor: 'wsGray.200',
      _checked: {
        bgColor: 'wsBlack',
        border: 'none',
      },
      _focus: {
        boxShadow: 'unset',
      },
    },
  },
};

export default Checkbox;
